import ActionTypes from '../../actionTypes'
const { GET_ALL_DATA_FAIL,GET_ALL_DATA_SUCCESS } = ActionTypes.REPORTS.HISTORIC_DATA

const initialState = {
  allHistoricData: [],
  dataCount: 0,
}

const historicDataReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case GET_ALL_DATA_SUCCESS:
      return {
        ...state,
        allHistoricData: payload.rows,
        dataCount: payload.count,
      }
    case GET_ALL_DATA_FAIL:
      return {
        ...state,
        allHistoricData: [],
        dataCount: 0,
      }
    default:
      return state
  }
}

export default historicDataReducer
